import { render, staticRenderFns } from "./CustomDivider.vue?vue&type=template&id=16473a7e&"
import script from "./CustomDivider.vue?vue&type=script&lang=js&"
export * from "./CustomDivider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports